import { Head } from '@inertiajs/react'
import { ReactNode } from 'react'
import FlashMessages from '@/frontend/components/FlashMessages'

interface Props {
  children: ReactNode
}

const OnboardingLayout: React.FC<Props> = ({ children }) => {
  return (
    <>
      <Head>
        <title>Bem-vindo ao StationZero</title>
      </Head>

      <div className="min-h-screen bg-[#fafafa] font-sans text-slate-800">
        <header className="flex items-center justify-center py-6">
          <a href="https://stationzero.ai">
            <img
              src="/landing/images/sz-orb-logo.png"
              alt="StationZero"
              className="h-7 object-contain"
            />
          </a>
        </header>

        <FlashMessages />

        <main className="mx-auto max-w-[960px] px-4 pb-16">
          {children}
        </main>
      </div>
    </>
  )
}

export default OnboardingLayout
